import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MatCheckbox} from '@angular/material/checkbox';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef,} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {AdresseModels} from 'src/app/models/adresse-models';
import {ObjektModels} from 'src/app/models/objekt-models';
import {AdresseDataService} from 'src/app/services/adresse-data.service';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {ObjektDataService} from 'src/app/services/objekt-data.service';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {v4 as uuidv4} from 'uuid';
import {AdressEintragComponent} from '../../adressen/adress-eintrag/adress-eintrag.component';
import {KontaktEintragComponent} from '../../adressen/kontakt-eintrag/kontakt-eintrag.component';

@Component({
    selector: 'app-objekt-adresse',
    templateUrl: './objekt-adresse.component.html',
    styleUrls: ['./objekt-adresse.component.scss'],
})
export class ObjektAdresseComponent implements OnInit {
    isLoadingResults = true;
    @ViewChild(MatPaginator) paginator?: MatPaginator;
    @ViewChild(MatCheckbox) cbOnlyActiveAddresses?: MatCheckbox;
    public onlyActive: boolean = true;
    public formDialoagMode: number = 1; // 1 = Adresszuweisung | 2 = Kontaktzuweisung
    contactIsChoosed: boolean = false;
    public adressTypes: AdresseModels.AddressTypes[] = [];
    public adrTypeDisabled: boolean = true;
    public canSave: boolean = false;
    // Spalten im Adressen-Grid
    dataSourceAdressen: MatTableDataSource<AdresseModels.AddressListElement>;
    displayedAdrColumns: string[] = [
        'adrnr',
        'name',
        'vorname',
        'adresse1',
        'adresse2',
        'zip',
        'city',
        'telefon',
        'natel',
        'email',
        'homepage',
    ];
    selectedAdressID: string = '';
    // Spalten im Ansprechpartner-Grid
    dataSourceAnsprechPartner: MatTableDataSource<AdresseModels.AnsprechPartnerListElement>;
    displayedAnsprechColumns: string[] = [
        'ha',
        'name',
        'vorname',
        'zuhanden',
        'briefanrede',
        'telefon',
        'natel',
        'email',
        'info',
        'pers',
    ];
    hasAnsprechPartner: number = 0;
    selectedAnsprechAdressID: string = '';
    // Neue Adresse erfassen
    currAdresse: AdresseModels.DetailAdresseElement;
    // Neuer Ansprechpartner erfassen
    currAnsprechPartner: AdresseModels.AnsprechPartnerElement;
    private dbAdressen: AdresseModels.AddressListElement[] = [];
    // Objekt, welches diesen Dialog aufgerufen hat
    private currObjectID: string = '';
    private currObjektAdresseZuord: ObjektModels.ObjektAdresseZuord;
    private filterValue: string = '';

    constructor(
        private svcAdressen: AdresseDataService,
        private svcObjekte: ObjektDataService,
        private svcMessageBox: MessageBoxService,
        private swissSettings: SwissSettingsService,
        public dialogRef: MatDialogRef<ObjektAdresseComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ObjektModels.ObjektAdresseDialogInput,
        public dialog: MatDialog
    ) {
        this.currObjectID = data.objektAdresseZuord.objectID;
        this.currObjektAdresseZuord = data.objektAdresseZuord;
        this.adrTypeDisabled = data.blDisableAdrTypeSelect;
        if (this.currObjektAdresseZuord.adressID) {
            this.selectedAdressID = this.currObjektAdresseZuord.adressID;
            this.formDialoagMode = 2; // Kontaktzuweisung wird geändert
            this.canSave = true;
        }

        this.dataSourceAdressen = new MatTableDataSource<AdresseModels.AddressListElement>();
        this.dataSourceAnsprechPartner = new MatTableDataSource<AdresseModels.AnsprechPartnerListElement>();
        this.loadAddresses();
        if (this.selectedAdressID) {
            if (this.currObjektAdresseZuord.contactID) {
                this.selectedAnsprechAdressID = this.currObjektAdresseZuord.contactID;
                this.contactIsChoosed = true;
            }
            this.loadAnsprechpartner();
        }

        this.currAdresse = AdresseModels.EmptyDetailAdresseElement(this.svcAdressen.getDefaultCountry());
        this.currAnsprechPartner = this.initCurrAnsprechPartner();
    }

    ngOnInit(): void {
        this.svcObjekte.getAddressTypen().subscribe({
            next: (res: AdresseModels.AddressTypes[]) => {
                this.adressTypes = res;
            },
            error: (err: any) =>
                console.error('Fehler bei der Ermittlung der Adresstypen'),
        });
    }

    highlight(row: any) {
        this.selectedAdressID = row.adressID;
        this.loadAnsprechpartner();
        this.checkAdressZuord();
    }

    highlightAP(row: any) {
        if (this.contactIsChoosed) {
            // demarkieren
            this.selectedAnsprechAdressID = '';
            this.contactIsChoosed = false;
        } else {
            this.selectedAnsprechAdressID = row.adressID;
            this.contactIsChoosed = true;
        }
    }

    loadAdressDataSourceByFilter() {
        // Die nächsten Zeilen müssen so bleiben, wegen der Performance.
        if (this.onlyActive) {
            this.dataSourceAdressen! =
                new MatTableDataSource<AdresseModels.AddressListElement>(
                    this.dbAdressen.filter((ale) => ale.inaktiv === false)
                );
        } else {
            this.dataSourceAdressen! =
                new MatTableDataSource<AdresseModels.AddressListElement>(
                    this.dbAdressen
                );
        }
    }

    checkAndChangeDataSourceForAddresses() {
        if (this.formDialoagMode === 2) {
            if (this.dataSourceAdressen!.data.length === 1) {
                this.loadAdressDataSourceByFilter();
            }
        }
    }

    applyFilter(event: any) {
        this.checkAndChangeDataSourceForAddresses();
        this.hasAnsprechPartner = 0;
        this.filterValue = (event.target as HTMLInputElement).value;
        this.dataSourceAdressen!.filter = this.filterValue.trim().toLowerCase();
    }

    modelChangeFn(e: any) {
        // Prüfen, ob das Objekt nicht bereits eine Kundenadresse hat
        this.checkAdressZuord();
    }

    setActive() {
        this.onlyActive = !this.onlyActive;
        this.loadAddresses();
    }

    save() {
        this.data.objektAdresseZuord.adressID = this.selectedAdressID;
        if (this.selectedAnsprechAdressID) {
            this.data.objektAdresseZuord.contactID = this.selectedAnsprechAdressID;
        } else {
            this.data.objektAdresseZuord.contactID = undefined;
        }
        this.dialogRef.close(this.data.objektAdresseZuord);
    }

    setAnsprechpartner(
        elem: AdresseModels.AnsprechPartnerListElement,
        event: any
    ) {
        // Es darf nur eine Person die Hauptansprechsperson sein
        this.dataSourceAnsprechPartner.data.forEach((partner) => {
            partner.hauptAnsprechpartner = 0;
            if (partner.adressID == elem.adressID) {
                partner.hauptAnsprechpartner = 1;
            }
        });

        // Änderungen gleich speichern
        this.svcAdressen
            .updateAdressPartner(
                this.dataSourceAnsprechPartner.data,
                this.selectedAdressID
            )
            .subscribe({
                next: (res) => {
                },
                error: (err) =>
                    console.error(
                        'Der Ansprechpartner konnte nicht aktualisiert werden. ',
                        err
                    ),
            });
    }

    // Die Spalte Pers bei den Ansprechpartner
    setAnsprechPersoenlich(
        elem: AdresseModels.AnsprechPartnerListElement,
        event: boolean
    ) {
        this.dataSourceAnsprechPartner.data.forEach((partner) => {
            if (partner.adressID == elem.adressID) {
                partner.pers = event == true ? 1 : 0;
            }
        });

        // Änderungen gleich speichern
        this.svcAdressen
            .updateAdressPartner(
                this.dataSourceAnsprechPartner.data,
                this.selectedAdressID
            )
            .subscribe({
                next: (res) => {
                },
                error: (err) =>
                    console.error(
                        'Persönlich konnte nicht auf dem Adresspartner gesetzt werden. ',
                        err
                    ),
            });
    }

    onNewAddress() {
        // Werte initialisieren
        this.currAdresse = AdresseModels.EmptyDetailAdresseElement(this.svcAdressen.getDefaultCountry());

        var dialogRef = this.dialog.open(AdressEintragComponent, {
            disableClose: true,
            width: '800px',
            data: this.currAdresse,
        });

        return dialogRef.afterClosed().subscribe({
            next: (result) => {
                if (result) {
                    this.currAdresse = result;
                    if (this.currAdresse) {
                        this.saveAddress();
                    }
                }
            },
        });
    }

    saveAddress() {
        // Neue oder bestehende Adresse wird gespeichert
        if (this.currAdresse.adressID == '') {
            this.currAdresse.adressID = uuidv4();
            this.svcAdressen.newAdresse(this.currAdresse).subscribe({
                next: (res) => {
                    if (this.swissSettings.getWebConfig().debugMode) {
                        console.log(res);
                    }
                    this.svcMessageBox.showSuccess(
                        'Die neue Adresse wurde erfolgreich gespeichert. ',
                        'Erfolgreich'
                    );
                    this.selectedAdressID = this.currAdresse.adressID;
                    this.filterValue = '';
                    this.loadAddresses();
                },
                error: (err) => {
                    console.error(err);
                    this.svcMessageBox.showError(
                        'Der Adresse wurde NICHT gespeichert. ',
                        'Fehler'
                    );
                }
            });
        }
    }

    onNewPartner() {
        // Werte initialisieren
        this.currAnsprechPartner = this.initCurrAnsprechPartner();

        var dialogRef = this.dialog.open(KontaktEintragComponent, {
            disableClose: true,
            width: '800px',
            data: this.currAnsprechPartner,
        });

        return dialogRef.afterClosed().subscribe({
            next: (result) => {
                if (result) {
                    this.currAnsprechPartner = result;

                    if (this.currAnsprechPartner) {
                        this.savePartner();
                    }
                }
            },
        });
    }

    savePartner() {
        if (this.currAnsprechPartner.adressID == '') {
            this.currAnsprechPartner.adressID = uuidv4();
            this.svcAdressen
                .newAdressPartner(this.currAnsprechPartner, this.selectedAdressID)
                .subscribe({
                    next: (res) => {
                        console.log(res);
                        this.svcMessageBox.showSuccess(
                            'Der Ansprechpartner wurde erfolgreich gespeichert. ',
                            'Erfolgreich'
                        );
                        this.selectedAnsprechAdressID = this.currAnsprechPartner.adressID;
                        this.loadAnsprechpartner();
                    },
                    error: (err) => {
                        console.error(err);
                        this.svcMessageBox.showError(
                            'Der Ansprechpartner wurde NICHT gespeichert. ',
                            'Fehler'
                        );
                    }
                });
        }
    }

    private checkAdressZuord() {
        if (this.data.blDoCheckUnique === true) {
            // Bestehendes Objekt
            if (this.selectedAdressID) {
                if (this.data.objektAdresseZuord.addressType === 1) {
                    this.data.objektAdresseZuord.adressID = this.selectedAdressID;
                    this.svcObjekte
                        .checkObjektZuordTypeUnique(this.data.objektAdresseZuord)
                        .then((res) => {
                            this.canSave = res;
                        });
                } else {
                    this.canSave = true;
                }
            } else {
                this.canSave = false;
            }
        } // Neues Objekt
        else {
            this.canSave = true;
        }
    }

    private loadAddresses() {
        this.svcAdressen.getAdressen().subscribe({
            next: (res: any[]) => {
                this.dbAdressen = res;
                this.loadAdressDataSourceByFilter();

                // Falls schon ein Suchbegriff eingegeben wurde, diesen nochmals verwenden
                if (this.filterValue) {
                    this.dataSourceAdressen!.filter = this.filterValue.trim().toLowerCase();

                    if (this.selectedAdressID) {
                        // Prüfen, ob die Adresse auch existiert
                        if (
                            this.dataSourceAdressen.data.findIndex((ale) => ale.adressID === this.selectedAdressID) < 0
                        ) {
                            this.selectedAdressID = '';
                        }
                    }
                } else {
                    if (this.selectedAdressID) {
                        // Die Adresse existiert.... alle anderen sind aktuell nicht mehr relevant
                        this.dataSourceAdressen! =
                            new MatTableDataSource<AdresseModels.AddressListElement>(
                                res.filter((ale) => ale.adressID === this.selectedAdressID)
                            );
                    }
                }

                this.paginator!.pageSize = 5;
                this.dataSourceAdressen!.paginator = this.paginator!;
                this.isLoadingResults = false;
            },
        });
    }

    private async loadAnsprechpartner() {
        // Ansprechspartner der aktuellen Adresseladen
        try {
            this.dataSourceAnsprechPartner!.data = await this.svcAdressen.getAnsprechpartnerByID(this.selectedAdressID);
            this.hasAnsprechPartner = 0;
            if (this.dataSourceAnsprechPartner.data.length > 0) {
                this.hasAnsprechPartner = 1;
            }
        } catch {
            console.error('Die Ansprechpartner der gewählten Adresse konnten nicht geladen werden');
        }
    }

    private initCurrAnsprechPartner(): AdresseModels.AnsprechPartnerElement {
        this.currAnsprechPartner = {
            adressID: '',
            adressNo: 0,
            hauptAnsprechpartner: 0,
            lastName: '',
            firstName: '',
            ansprechInfo: '',
            anrede: '',
            briefanrede: '',
            zuhanden: '',
            telefon: '',
            mobile: '',
            email: '',
            homepage: '',
            pers: 0,
        };
        return this.currAnsprechPartner;
    }
}
